import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const ExtensionServices = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Extension Services (Seminars & Workshops)</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) provides extension services through seminars and workshops to enhance knowledge, compliance, and skills among stakeholders.
          </p>
          <p className="subtitle">
            These programs aim to promote awareness of standards, quality management, and regulatory requirements across industries and institutions.
          </p>
        </div>
      </section>

      {/* === Services Offered Section === */}
      <section className="intro-section">
        <h2 className="section-title">Extension Services Programs</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Industry-focused seminars on standards and quality management</li>
              <li>Workshops on regulatory compliance and safety requirements</li>
              <li>Training on inspection, verification, and certification processes</li>
              <li>Awareness programs for SMEs and startups on product quality</li>
              <li>Capacity building for professionals in laboratories and industry</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Technical workshops on measurement, calibration, and metrology</li>
              <li>Consumer awareness seminars on product safety and standards</li>
              <li>Interactive sessions for quality improvement and process optimization</li>
              <li>Specialized training on management systems and accreditation</li>
              <li>Networking opportunities with MBS experts and industry peers</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Calendar & Registration Section === */}
      <section className="functions-section">
        <h2 className="section-title">Seminar & Workshop Calendar</h2>
        <p>
          MBS publishes an annual calendar of seminars and workshops. This calendar provides dates, venues, and registration procedures to help stakeholders plan participation in relevant programs.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Extension Services</h2>
        <p>
          For inquiries, registration, or more information on seminars and workshops, please contact the MBS Extension Services team.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:extension@mbs.mw">extension@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 333</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          MBS Extension Services seminars and workshops empower stakeholders with knowledge, skills, and awareness to uphold quality, safety, and compliance in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default ExtensionServices;
